
import { Autocomplete, Button, Modal, TextField } from "@mui/material";
import "./ImportConfig.css";
import { useState } from "react";
import { validateWithOtp } from "../../stateManagement/actions/validateOtpPopupActions";
import { fetchConfigToImport, getLobListFromEnv } from "../../services/uiConfigService";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";


interface ImportConfigProps {
    importConfigState:boolean;
    setImportConfigState: React.Dispatch<React.SetStateAction<boolean>>;
    importConfigCallback:any;
    configNames:string[];
}

const ImportConfig = (props:ImportConfigProps)=>{

    const { translate } = usePortalTranslation();
    const envOptions = ['uat', 'demo', 'prod'];
    const [selectedEnv,setSelectedEnv] = useState<string>("");
    const [selectedLob,setSelectedLob] = useState<string>("");
    const [availableLobOptions,setAvailableLobOptions] = useState<string[]>([]);

    const handleClose = ()=>{
        props.setImportConfigState(false)
    }

    const validateAndFetchConfig = async ()=>{
        props.setImportConfigState(false)
        // validateWithOtp(async()=>{
            try{
                const importedConfig = await fetchConfigToImport(selectedEnv,selectedLob);
                const configsToReturn = importedConfig.data.features.filter((feature:any)=>props.configNames.includes(feature.domainType))
                if(configsToReturn.length){
                    props.importConfigCallback(configsToReturn)
                }else{
                    openPopup("Error","Config not available in selected LOB")    
                }
            }catch(error){
                openPopup("Error","Config Import failed")
                console.error(error)
            }
        // },['uat'],'all');
    }

    const handleLobChange = async (event:React.SyntheticEvent<Element, Event>,selectedLob:string|null)=>{
        if(!selectedLob){
            setSelectedLob("")
            return
        }
        setSelectedLob(selectedLob)
    }
    const handleEnvChange = async (event:React.SyntheticEvent<Element, Event>,selectedEnv:string|null)=>{
        if(!selectedEnv){
            setSelectedEnv("");
            setSelectedLob("")
            return
        }
        setSelectedEnv(selectedEnv);
        const lobOptions = await getLobListFromEnv(selectedEnv);
        setAvailableLobOptions(lobOptions)
        setSelectedLob("")
    }
    
    return(
        <Modal
            open={props.importConfigState}
            onClose={handleClose}
        >
            <div className="import-config-container">
                <div className="import-config-header">
                    {translate(TranslationEnum.ui_config,"Import Config")}
                </div>
                <div className="import-config-input-container">
                    <Autocomplete
                        disablePortal
                        className="import-config-input"
                        value={selectedEnv}
                        id="importConfigEnv"
                        options={envOptions}
                        onChange={handleEnvChange}
                        renderInput={(params) => <TextField {...params}  label="Select Environment" />}
                    />
                    <Autocomplete
                        disablePortal
                        className="import-config-input"
                        value={selectedLob}
                        id="importConfigLob"
                        options={availableLobOptions}
                        onChange={handleLobChange}
                        renderInput={(params) => <TextField {...params}  label="Select Lob" />}
                    />
                    
                </div>
                <div className="import-config-action-container">
                    <Button className="import-config-action-button" onClick={validateAndFetchConfig} disabled={selectedLob ? false : true}>
                        {translate(TranslationEnum.ui_config,"Import")}
                    </Button>
                    <Button className="import-config-action-button" onClick={handleClose}>
                        {translate(TranslationEnum.ui_config,"Cancel")}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}


export default ImportConfig;